import Svg, { Circle, Path } from 'react-native-svg'

interface StampMotifProps {
  size: number
  color: string
}

export function StampMotif({ size, color }: StampMotifProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 830 653">
      <Circle cx="758.5" cy="559.5" r="71.5" fill={color} stroke={color} strokeWidth={1} />
      <Path
        fillRule="evenodd"
        d="M396,0c94.471-1.868,154.91,22.534,207,62,31.086,23.552,45.267,67.56,16,105-13.807,17.662-52.348,29.7-81,17-17.748-7.865-31.134-23.863-50-32l-45-12c-24.918-4.6-55.352.261-74,6-76.55,23.558-113.456,76.858-128,163-19.174,113.56,87.028,230,197,210l49-13c32.062-13.784,65.265-55.9,113-25,28.647,18.541,38.364,67.294,15,99-29.911,40.591-103.544,61.34-165,72-52.98,9.19-112.348-4.511-148-19C187.771,586.578,101.016,490.553,101,331c0-43.387,3.862-78.5,15-111,31.441-91.753,95.058-161.84,182-198,19.709-8.2,41.464-13.247,64-18Z"
        fill={color}
      />
    </Svg>
  )
}
